import axios from 'axios'

// F4 — Formula Builder store. Thin axios wrappers around the bid-evaluation microservice
// (VUE_APP_BIDEVAL — same service as /offer/vendorcolumns). The FE never computes values:
// it sends the slot-based formula; the BE validates, persists and computes all cells.
//
// Shared R4S identifiers for every call: { offer_id, vendor_id, category, context, token }
//   context = 'initial' | 'bafo'
// Error convention (400): { status, data: '<CODE>', message } where CODE is one of
//   INVALID_FORMULA | FORMULA_CYCLE | FORMULA_ENGINE_UNAVAILABLE.

const state = {}
const mutations = {}

// Per-column formula endpoint. Bulk (MTO) has its own route; Tagged/Packages keep the default.
function formulaPath(params) {
  return params && params.category === 'bulk' ? '/bulk/offer/formula' : '/offer/formula'
}

const actions = {
  // GET operator whitelist — drives the dialog palette. → data.operators[{ value, label, num_operands }]
  fetchOperators({ commit }, params) {
    return axios.get(`${process.env.VUE_APP_BIDEVAL}/formula/operators`, { params })
  },
  // POST save — per-column upsert keyed by target_column_id (no table_id in R4S). The FE sends
  // just the edited formula. Body: { ...ids, formulas: [{ target_column_id, expression, operands }] }
  // Bulk category routes to the Bulk-specific endpoint (/bulk/offer/formula); T&P keeps /offer/formula.
  saveFormula({ commit }, params) {
    return axios.post(`${process.env.VUE_APP_BIDEVAL}${formulaPath(params)}`, params)
  },
  // GET a saved formula — keyed by target_column_id (REQUIRED). Returns ONE formula object in
  // data: { target_column_id, target_column_name, expression, operands, display_expression, is_valid }.
  // Drives the fx badge state, header tooltip, dialog preload and read-only flag for that column.
  fetchFormulas({ commit }, params) {
    return axios.get(`${process.env.VUE_APP_BIDEVAL}${formulaPath(params)}`, { params })
  },
  // DELETE — per-column: removes this column's formula. Body: { ...ids, target_column_id }.
  deleteFormulas({ commit }, params) {
    return axios.delete(`${process.env.VUE_APP_BIDEVAL}${formulaPath(params)}`, { data: params })
  },
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
